<template>
  <main class="superpasses__wrapper">
    <div class="table-selector">
      <button
        @click="selectTable('superpasses')"
        :class="{ active: selectedTable === 'superpasses' }"
      >
        Superpasses
      </button>
      <button @click="selectTable('giftcards')" :class="{ active: selectedTable === 'giftcards' }">
        Gift Cards
      </button>
    </div>

    <div class="table-container" v-if="selectedTable === 'superpasses'">
      <table>
        <thead>
          <tr>
            <th>ID</th>
            <th>User ID</th>
            <th>Superpass Name</th>
            <th>Game Name</th>
            <th>Amount</th>
            <th>Robux Amount</th>
            <th>Status</th>
            <th>Date</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in paginatedData" :key="item.id">
            <td>{{ item.id }}</td>
            <td>{{ item.user_id }}</td>
            <td>{{ item.superpass }}</td>
            <td>{{ item.game }}</td>
            <td>{{ formatAmount(item.amount) }}</td>
            <td>{{ item.robux_amount }}</td>
            <td>{{ item.status }}</td>
            <td>{{ new Date(item.date).toLocaleString() }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="table-container" v-if="selectedTable === 'giftcards'">
      <table>
        <thead>
          <tr>
            <th>ID</th>
            <th>User ID</th>
            <th>Amount</th>
            <th>Robux Amount</th>
            <th>Status</th>
            <th>Created At</th>
            <th>Code</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in paginatedData" :key="item.id">
            <td>{{ item.id }}</td>
            <td>{{ item.user_id }}</td>
            <td>{{ formatAmount(item.amount) }}</td>
            <td>{{ item.robux_amount }}</td>
            <td>{{ item.status }}</td>
            <td>{{ new Date(item.created_at).toLocaleString() }}</td>
            <td>{{ item.code }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="pagination" v-if="totalPages > 1">
      <button @click="prevPage" :disabled="currentPage === 1">←</button>
      <button
        v-for="page in paginationRange"
        :key="page"
        @click="goToPage(page)"
        :class="{ selected: page === currentPage }"
        :disabled="page === '...'"
      >
        {{ page }}
      </button>
      <button @click="nextPage" :disabled="currentPage === totalPages">→</button>
    </div>
  </main>
</template>

<script>
import './superpasses.scss'

import Loader from '../../components/Loader/Loader'

export default {
  name: 'SuperPasses',
  components: {
    Loader
  },
  data() {
    return {
      selectedTable: 'superpasses',
      superpasses: [],
      giftCards: [],
      currentPage: 1,
      itemsPerPage: 10,
      superpassesTotalCount: 0,
      giftCardsTotalCount: 0
    }
  },
  watch: {
    selectedTable: {
      handler(newTable) {
        this.currentPage = 1
        if (newTable === 'superpasses') {
          this.fetchSuperpasses(1)
        } else if (newTable === 'giftcards') {
          this.fetchGiftCards(1)
        }
      },
      immediate: true
    },
    currentPage(newPage, oldPage) {
      if (newPage !== oldPage) {
        if (this.selectedTable === 'superpasses') {
          this.fetchSuperpasses(newPage)
        } else if (this.selectedTable === 'giftcards') {
          this.fetchGiftCards(newPage)
        }
      }
    }
  },
  computed: {
    currentData() {
      return this.selectedTable === 'superpasses' ? this.superpasses : this.giftCards
    },
    totalPages() {
      if (this.selectedTable === 'superpasses') {
        return Math.ceil(this.superpassesTotalCount / this.itemsPerPage)
      }
      if (this.selectedTable === 'giftcards') {
        return Math.ceil(this.giftCardsTotalCount / this.itemsPerPage)
      }
      return 1
    },
    paginatedData() {
      return this.currentData
    },
    paginationRange() {
      const total = this.totalPages
      const current = this.currentPage
      const delta = 2
      const range = []
      let l

      for (let i = 1; i <= total; i++) {
        if (i === 1 || i === total || (i >= current - delta && i <= current + delta)) {
          range.push(i)
        } else if (l && l !== '...') {
          range.push('...')
        }
        l = range[range.length - 1]
      }

      return range
    }
  },
  mounted() {},
  methods: {
    async fetchSuperpasses(page) {
      const perPage = this.itemsPerPage
      try {
        const response = await fetch(
          `https://robux.apineural.com/superpasses/orders/history?page=${page}&per_page=${perPage}`,
          {
            headers: {
              Authorization: `Bearer ${this.$store.state.tokens.access}`
            }
          }
        )
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`)
        }
        const data = await response.json()
        this.superpasses = data.orders
        this.superpassesTotalCount = data.count
      } catch (error) {
        console.error('Error fetching superpasses:', error)
        this.superpasses = []
        this.superpassesTotalCount = 0
      }
    },
    async fetchGiftCards(page) {
      const perPage = this.itemsPerPage
      try {
        const response = await fetch(
          `https://robux.apineural.com/giftcards/orders/history?page=${page}&per_page=${perPage}`,
          {
            headers: {
              Authorization: `Bearer ${this.$store.state.tokens.access}`
            }
          }
        )
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`)
        }
        const data = await response.json()
        this.giftCards = data.orders
        this.giftCardsTotalCount = data.count
      } catch (error) {
        console.error('Error fetching gift cards:', error)
        this.giftCards = []
        this.giftCardsTotalCount = 0
      }
    },
    formatAmount(amount) {
      if (amount.rub) return `${amount.rub} RUB`
      if (amount.usd) return `${amount.usd} USD`
      if (amount.eur) return `${amount.eur} EUR`
      return 'N/A'
    },
    selectTable(table) {
      this.selectedTable = table
    },
    goToPage(page) {
      if (page !== '...') {
        this.currentPage = page
      }
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++
      }
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--
      }
    }
  }
}
</script>
